import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@upme/ui/components/alert-dialog';
import { toast } from 'sonner';
import { type AdminNewsRow, useDeleteNews } from '../queries';

interface Props {
  news: AdminNewsRow;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteNewsDialog({ news, open, onOpenChange }: Props) {
  const del = useDeleteNews();

  const handleConfirm = async () => {
    try {
      await del.mutateAsync(news.id);
      toast.success('Новость удалена');
      onOpenChange(false);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Не удалось удалить';
      toast.error(message);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogTrigger asChild>
        <span />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Удалить новость?</AlertDialogTitle>
          <AlertDialogDescription>
            «{news.title}» будет удалена без возможности восстановления.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction disabled={del.isPending} onClick={handleConfirm}>
            {del.isPending ? 'Удаление…' : 'Удалить'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
